module.exports = "https://static.energy5.com/_next/static/images/benefitsBg-26c4f42c7eb6025e309718f2086a5971.png";